import { render, staticRenderFns } from "./DeviceOverview.vue?vue&type=template&id=482fe2ec&scoped=true"
import script from "./DeviceOverview.vue?vue&type=script&lang=js"
export * from "./DeviceOverview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "482fe2ec",
  null
  
)

export default component.exports